import { Component } from '@angular/core';

@Component({
  selector: 'app-onboarding-wrapper',
  templateUrl: './onboarding-wrapper.component.html'
})
export class OnboardingWrapperComponent {
}
